import React from "react";

const CountrySelectItem = ({ flag, name, phoneCode, code }) => {
  return (
    <div className="flex items-center space-x-2">
      {flag && <span className="text-lg leading-none">{flag}</span>}
      {phoneCode && <span className="text-sm text-gray-600">(+{phoneCode})</span>}
      <span className="text-sm font-medium">{name}</span>
      {code && <span className="text-xs text-gray-500">- {code}</span>}
    </div>
  );
};

export default CountrySelectItem;
